import { createRoot } from "react-dom/client";
import App from "./App";
import { purgeOnDeviceAICache } from "./lib/purgeOnDeviceAICache";
import "./fonts.css";
import "./index.css";

// Task #103: clear the ~280MB transformers.js model cache + legacy
// localStorage flags left over from the removed on-device AI runtime.
// No-op after the first successful run on each browser.
purgeOnDeviceAICache();

createRoot(document.getElementById("root")!).render(<App />);
